import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import classNames from 'classnames';
import * as styles from './styles.css';
export var RememberedAccountsLayout = function RememberedAccountsLayout(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    content = _ref.content,
    controls = _ref.controls;
  var deviceType = useDeviceType();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['container'], styles["container--".concat(deviceType)])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles['sub-title']
  }, subTitle), content, /*#__PURE__*/React.createElement("div", {
    className: styles['controls']
  }, controls.map(function (Component, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "controls_".concat(index),
      className: styles['controls-row']
    }, Component);
  })));
};